/* Designs — header, mobile nav, and predictive search interactions */
(() => {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const searchToggle = header.querySelector('[data-search-toggle]');
  const searchClose = header.querySelector('[data-search-close]');
  const searchOverlay = header.querySelector('[data-search-overlay]');

  const mobileToggle = header.querySelector('[data-mobile-nav-toggle]');
  const mobileDrawer = header.querySelector('[data-mobile-nav-drawer]');

  const navItems = Array.from(header.querySelectorAll('.has-dropdown'));

  const closeSearch = () => {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    header.classList.remove('is-search-open');
  };

  const closeDrawer = () => {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('is-open');
    header.classList.remove('is-drawer-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    header.querySelectorAll('.mobile-nav-item--has-children').forEach((item) => {
      item.classList.remove('is-open');
      const panel = item.querySelector('[data-mobile-subnav]');
      const toggle = item.querySelector('[data-mobile-subnav-toggle]');
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  };

  const openSearch = () => {
    if (!searchOverlay) return;
    closeDrawer();
    searchOverlay.classList.add('is-open');
    header.classList.add('is-search-open');
    const input = searchOverlay.querySelector('input[type="search"]');
    if (input) setTimeout(() => input.focus(), 50);
  };

  const openDrawer = () => {
    if (!mobileDrawer) return;
    closeSearch();
    mobileDrawer.classList.add('is-open');
    header.classList.add('is-drawer-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
  };

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (searchOverlay.classList.contains('is-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    });
  }

  if (searchClose) {
    searchClose.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeSearch();
    });
  }

  if (mobileToggle && mobileDrawer) {
    mobileToggle.setAttribute('aria-expanded', 'false');

    const handleDrawerToggle = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (mobileDrawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    };

    mobileToggle.addEventListener('click', handleDrawerToggle, { passive: false });
  }

  navItems.forEach((item) => {
    const trigger = item.querySelector('.nav-link--parent');
    if (!trigger) return;

    trigger.addEventListener('click', (event) => {
      if (window.innerWidth > 1100) return;
      const isOpen = item.classList.contains('is-open');
      navItems.forEach((other) => other.classList.remove('is-open'));
      if (!isOpen) {
        event.preventDefault();
        item.classList.add('is-open');
      }
    });
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (searchOverlay && searchOverlay.classList.contains('is-open') && !searchOverlay.contains(target) && !searchToggle?.contains(target)) {
      closeSearch();
    }

    if (mobileDrawer && mobileDrawer.classList.contains('is-open') && !mobileDrawer.contains(target) && !mobileToggle?.contains(target)) {
      closeDrawer();
    }

    if (!target.closest('.has-dropdown')) {
      navItems.forEach((item) => item.classList.remove('is-open'));
    }
  });


  const searchForm = header.querySelector('[data-predictive-search-form]');
  const searchInput = header.querySelector('[data-predictive-search-input]');
  const searchDefaultContent = header.querySelector('[data-search-default-content]');
  const searchResults = header.querySelector('[data-predictive-search-results]');

  let predictiveController;
  let predictiveTimer;

  const escapeHtml = (str = '') =>
    str.replace(/[&<>"']/g, (m) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[m]));

  const money = (value) => {
    if (typeof value !== 'number') return '';
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    }).format(value / 100);
  };

  const clearPredictiveResults = () => {
    if (searchResults) {
      searchResults.innerHTML = '';
      searchResults.hidden = true;
    }
    if (searchDefaultContent) searchDefaultContent.hidden = false;
  };

  const renderPredictiveResults = (data, term) => {
    if (!searchResults) return;

    const resources = data?.resources?.results || {};
    const products = resources.products || [];
    const collections = resources.collections || [];
    const pages = resources.pages || [];
    const articles = resources.articles || [];
    const queries = resources.queries || [];

    const hasResults = products.length || collections.length || pages.length || articles.length || queries.length;

    if (!hasResults) {
      searchResults.innerHTML = `
        <div class="search-results-live__empty search-results-live__empty--ghost">
          <p class="search-overlay__eyebrow">No results</p>
          <p>No matches found for “${escapeHtml(term)}”.</p>
        </div>
      `;
      searchResults.hidden = false;
      if (searchDefaultContent) searchDefaultContent.hidden = true;
      return;
    }

    
const productHtml = products.map((product) => {
  const imageUrl = product.featured_image?.url || product.image || '';
  const priceMin = product.price?.min ?? product.price_min;
  return `
    <a class="predictive-item predictive-item--product predictive-item--ghost" href="${product.url}">
      ${imageUrl ? `<div class="predictive-item__image-wrap"><img class="predictive-item__image" src="${imageUrl}" alt="${escapeHtml(product.title)}"></div>` : `<div class="predictive-item__image predictive-item__image--empty"></div>`}
      <div class="predictive-item__content">
        <div class="predictive-item__type">Product</div>
        <div class="predictive-item__title">${escapeHtml(product.title)}</div>
        ${typeof priceMin === 'number' ? `<div class="predictive-item__meta">${money(priceMin)}</div>` : ``}
      </div>
    </a>
  `;
}).join('');


    const linkList = (items, label) => items.map((item) => `
      <a class="predictive-link" href="${item.url}">
        <span class="predictive-link__type">${label}</span>
        <span class="predictive-link__title">${escapeHtml(item.title || item.text)}</span>
      </a>
    `).join('');

    
searchResults.innerHTML = `
  <div class="search-results-live__grid search-results-live__grid--ghost">
    <div class="search-results-live__rail">
      ${queries.length ? `
        <div class="predictive-group">
          <p class="search-overlay__eyebrow">Suggestions</p>
          <div class="predictive-links predictive-links--stacked">
            ${queries.map((q) => `
              <a class="predictive-link" href="${q.url}">
                <span class="predictive-link__title">${q.styled_text || escapeHtml(q.text)}</span>
              </a>
            `).join('')}
          </div>
        </div>
      ` : ''}

      ${(collections.length || pages.length || articles.length) ? `
        <div class="predictive-group">
          <p class="search-overlay__eyebrow">Explore</p>
          <div class="predictive-links predictive-links--stacked">
            ${linkList(collections, 'Collection')}
            ${linkList(pages, 'Page')}
            ${linkList(articles, 'Article')}
          </div>
        </div>
      ` : ''}
    </div>

    <div class="search-results-live__feature">
      ${products.length ? `
        <div class="predictive-group">
          <p class="search-overlay__eyebrow">Featured</p>
          <div class="predictive-products predictive-products--ghost">
            ${productHtml}
          </div>
        </div>
      ` : ''}
    </div>
  </div>

  <div class="search-results-live__footer search-results-live__footer--ghost">
    <a class="button button--solid" href="/search?q=${encodeURIComponent(term)}">View all results</a>
  </div>
`;


    searchResults.hidden = false;
    if (searchDefaultContent) searchDefaultContent.hidden = true;
  };

  const fetchPredictiveResults = async (term) => {
    if (!term || term.trim().length < 2) {
      clearPredictiveResults();
      return;
    }

    if (predictiveController) predictiveController.abort();
    predictiveController = new AbortController();

    const rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    const url = `${rootUrl}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,collection,page,article,query&resources[limit]=8`;

    try {
      const response = await fetch(url, {
        signal: predictiveController.signal,
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) throw new Error('Predictive search failed');

      const data = await response.json();
      renderPredictiveResults(data, term);
    } catch (error) {
      if (error.name === 'AbortError') return;
      clearPredictiveResults();
    }
  };

  if (searchInput) {
    searchInput.addEventListener('input', (event) => {
      const term = event.target.value || '';
      window.clearTimeout(predictiveTimer);
      predictiveTimer = window.setTimeout(() => {
        fetchPredictiveResults(term);
      }, 180);
    });
  }

  if (searchForm) {
    searchForm.addEventListener('submit', () => {
      closeSearch();
    });
  }


  const mobileSubnavToggles = Array.from(header.querySelectorAll('[data-mobile-subnav-toggle]'));

  mobileSubnavToggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      const item = toggle.closest('.mobile-nav-item--has-children');
      const panel = item?.querySelector('[data-mobile-subnav]');
      if (!item || !panel) return;

      const isOpen = item.classList.contains('is-open');

      mobileSubnavToggles.forEach((otherToggle) => {
        const otherItem = otherToggle.closest('.mobile-nav-item--has-children');
        const otherPanel = otherItem?.querySelector('[data-mobile-subnav]');
        if (!otherItem || !otherPanel) return;
        otherItem.classList.remove('is-open');
        otherToggle.setAttribute('aria-expanded', 'false');
        otherPanel.hidden = true;
      });

      if (!isOpen) {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeSearch();
    closeDrawer();
    navItems.forEach((item) => item.classList.remove('is-open'));
  });
})();




/* Stable account drawer + dashboard tabs */
(() => {
  const drawer = document.querySelector('[data-account-drawer]');
  const openButtons = document.querySelectorAll('[data-account-open]');
  const closeButtons = document.querySelectorAll('[data-account-close]');

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('account-drawer-open');
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('account-drawer-open');
  };

openButtons.forEach((button) => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    const header = document.querySelector('[data-site-header]');
    const mobileDrawer = document.querySelector('[data-mobile-nav-drawer]');
    const mobileToggle = document.querySelector('[data-mobile-nav-toggle]');

    if (mobileDrawer) mobileDrawer.classList.remove('is-open');
    if (header) header.classList.remove('is-drawer-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');

    document.querySelectorAll('.mobile-nav-item--has-children').forEach((item) => {
      item.classList.remove('is-open');
      const panel = item.querySelector('[data-mobile-subnav]');
      const toggle = item.querySelector('[data-mobile-subnav-toggle]');
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });

    openDrawer();
  });
});

  closeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      closeDrawer();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  const accountTabs = document.querySelectorAll('[data-account-tab]');
  const accountPanels = document.querySelectorAll('[data-account-panel]');

  accountTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-account-tab');
      accountTabs.forEach((item) => item.classList.remove('is-active'));
      accountPanels.forEach((panel) => panel.classList.remove('is-active'));
      tab.classList.add('is-active');
      const panel = document.querySelector(`[data-account-panel="${target}"]`);
      if (panel) panel.classList.add('is-active');
    });
  });
})();


/* Account drawer gateway logic */
(() => {
  const drawer = document.querySelector('[data-account-drawer]');
  const openButtons = document.querySelectorAll('[data-account-open]');
  const closeButtons = document.querySelectorAll('[data-account-close]');

  if (!drawer) return;

  const openDrawer = () => {
    drawer.classList.add('is-open');
    document.body.classList.add('account-drawer-open');
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    document.body.classList.remove('account-drawer-open');
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      openDrawer();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      closeDrawer();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });
})();




/* Premium account dashboard tabs */
(() => {
  const tabs = document.querySelectorAll('[data-account-tab]');
  const panels = document.querySelectorAll('[data-account-panel]');
  if (!tabs.length || !panels.length) return;

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-account-tab');
      tabs.forEach((item) => item.classList.remove('is-active'));
      panels.forEach((panel) => panel.classList.remove('is-active'));
      tab.classList.add('is-active');
      const active = document.querySelector(`[data-account-panel="${target}"]`);
      if (active) active.classList.add('is-active');
    });
  });
})();




/* Members Only origin-safe link */
document.querySelectorAll('[data-members-only-link]').forEach((link) => {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    window.location.href = window.location.origin + '/pages/account-dashboard';
  });
});




/* Ghost-close cart drawer */
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const openButtons = document.querySelectorAll('[data-cart-open]');
  const closeButtons = document.querySelectorAll('[data-cart-close]');
  const itemsWrap = document.querySelector('[data-cart-items]');
  const subtotalEls = document.querySelectorAll('[data-cart-subtotal]');
  const countEls = document.querySelectorAll('[data-cart-count-label], [data-cart-count-label-footer]');
  const body = document.body;

  if (!drawer || !itemsWrap) return;

  const money = (value) => {
    if (typeof value !== 'number') return '';
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    }).format(value / 100);
  };

  const openDrawer = async () => {
    drawer.classList.add('is-open');
    body.classList.add('cart-drawer-open');
    await renderCart();
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    body.classList.remove('cart-drawer-open');
  };

  const updateCountBadges = (count) => {
    document.querySelectorAll('.cart-count').forEach((el) => {
      if (count > 0) {
        el.textContent = count;
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });
  };

  const renderEmpty = () => {
    itemsWrap.innerHTML = `
      <div class="cart-drawer__empty">
        <h3>Your cart is empty</h3>
        <p>Add something good and it’ll show up here.</p>
      </div>
    `;
  };

  const itemMarkup = (item) => `
    <article class="cart-line" data-line-key="${item.key}">
      <a href="${item.url}" class="cart-line__image">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ``}
      </a>
      <div class="cart-line__content">
        <div class="cart-line__top">
          <div>
            <a href="${item.url}" class="cart-line__title">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${item.variant_title}</div>` : ``}
          </div>
          <button type="button" class="cart-line__remove" data-cart-remove="${item.key}" aria-label="Remove item">×</button>
        </div>
        <div class="cart-line__bottom">
          <div class="cart-line__qty">
            <button type="button" data-cart-qty="${item.key}" data-cart-qty-change="-1">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-qty="${item.key}" data-cart-qty-change="1">+</button>
          </div>
          <div class="cart-line__price">${money(item.final_line_price)}</div>
        </div>
      </div>
    </article>
  `;

  const bindCartActions = () => {
    itemsWrap.querySelectorAll('[data-cart-remove]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        await updateLine(btn.getAttribute('data-cart-remove'), 0);
      });
    });
    itemsWrap.querySelectorAll('[data-cart-qty]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key = btn.getAttribute('data-cart-qty');
        const change = parseInt(btn.getAttribute('data-cart-qty-change'), 10);
        const line = btn.closest('.cart-line');
        const qtyText = line?.querySelector('.cart-line__qty span')?.textContent || '1';
        const nextQty = Math.max(0, parseInt(qtyText, 10) + change);
        await updateLine(key, nextQty);
      });
    });
  };

  const renderCart = async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      countEls.forEach((el) => {
        el.textContent = `(${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'})`;
      });
      subtotalEls.forEach((el) => el.textContent = money(cart.total_price));
      updateCountBadges(cart.item_count);

      if (!cart.items.length) {
        renderEmpty();
        return;
      }

      itemsWrap.innerHTML = cart.items.map(itemMarkup).join('');
      bindCartActions();
    } catch (e) {
      itemsWrap.innerHTML = '<div class="cart-drawer__empty"><h3>Unable to load cart</h3></div>';
    }
  };

  const updateLine = async (key, quantity) => {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await renderCart();
  };

  openButtons.forEach((btn) => btn.addEventListener('click', async (e) => {
    e.preventDefault();
    await openDrawer();
  }));
  closeButtons.forEach((btn) => btn.addEventListener('click', (e) => {
    e.preventDefault();
    closeDrawer();
  }));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  document.querySelectorAll('[data-upsell-add]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const card = btn.closest('[data-upsell-product]');
      const input = card?.querySelector('[data-upsell-variant]');
      if (!input) return;
      btn.disabled = true;
    });
  });

  document.querySelectorAll('[data-upsell-add]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const card = btn.closest('[data-upsell-product]');
      const input = card?.querySelector('[data-upsell-variant]');
      if (!input) return;
      const id = input.value;
      const previous = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'ADDING';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        await renderCart();
        btn.textContent = 'ADDED';
        setTimeout(() => { btn.textContent = previous; btn.disabled = false; }, 800);
      } catch (e) {
        btn.textContent = 'ERROR';
        setTimeout(() => { btn.textContent = previous; btn.disabled = false; }, 800);
      }
    });
  });
})();




/* AJAX product add-to-cart -> cart drawer */
(() => {
  const shouldInterceptProductForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return false;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (action.includes('/cart/add')) return true;
    if (form.matches('form[action*="/cart/add"]')) return true;
    if (form.querySelector('input[name="id"]') && form.querySelector('button[type="submit"], input[type="submit"]')) return true;
    return false;
  };

  const openCartDrawer = async () => {
    const cartOpen = document.querySelector('[data-cart-open]');
    if (cartOpen) {
      cartOpen.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!shouldInterceptProductForm(form)) return;

    event.preventDefault();

    const submitter = document.activeElement;
    const originalText = submitter && ('value' in submitter ? submitter.value : submitter.textContent);

    try {
      if (submitter) {
        submitter.disabled = true;
        if ('value' in submitter && typeof submitter.value === 'string') submitter.value = 'ADDING';
        else if ('textContent' in submitter) submitter.textContent = 'ADDING';
      }

      const formData = new FormData(form);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      if (!response.ok) throw new Error('Add to cart failed');

      await openCartDrawer();
    } catch (error) {
      console.error(error);
      window.location.href = '/products';
    } finally {
      if (submitter) {
        submitter.disabled = false;
        if ('value' in submitter && typeof originalText === 'string') submitter.value = originalText;
        else if ('textContent' in submitter && typeof originalText === 'string') submitter.textContent = originalText;
      }
    }
  });
})();








/* Collection quick-buy */
(() => {
  const money = (value) => {
    if (typeof value !== 'number') return '';
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    }).format(value / 100);
  };

  const resolveVariant = (state, variants) => {
    return variants.find((variant) => {
      const options = [variant.option1, variant.option2, variant.option3];
      return state.every((value, index) => {
        if (value === null || value === undefined || value === '') return true;
        return options[index] === value;
      });
    });
  };

  const setupCard = (card) => {
    const quickBuy = card.querySelector('[data-card-quick-buy]');
    if (!quickBuy) return;

    let variants = [];
    let optionNames = [];
    try {
      variants = JSON.parse(quickBuy.getAttribute('data-product-variants') || '[]');
      optionNames = JSON.parse(quickBuy.getAttribute('data-product-options') || '[]');
    } catch (e) {
      return;
    }

    if (!variants.length) return;

    const colorImageMap = {};
    quickBuy.querySelectorAll('[data-card-color-images] [data-color-name]').forEach((node) => {
      const color = node.getAttribute('data-color-name');
      const image = node.getAttribute('data-color-image');
      if (color && image) colorImageMap[color] = image;
    });

    const optionState = Array(optionNames.length).fill(null);
    const defaultVariant = variants.find(v => String(v.id) === String(quickBuy.getAttribute('data-default-variant-id'))) || variants[0];
    const colorPos = quickBuy.getAttribute('data-color-option-position');
    const sizePos = quickBuy.getAttribute('data-size-option-position');
    const colorIndex = colorPos ? Number(colorPos) - 1 : null;
    const sizeIndex = sizePos ? Number(sizePos) - 1 : null;
    const priceNode = card.querySelector('[data-card-price]');
    const hiddenVariantInput = quickBuy.querySelector('[data-card-variant-id]');
    const addButton = quickBuy.querySelector('[data-card-add]');
    const image = card.querySelector('[data-card-main-image]');
    const hoverImg = card.querySelector('.product-card__img--hover');
    const setHoverImage = (src) => {
  if (!hoverImg) return;

  if (src) {
    const normalizedSrc = src.replace(/&width=\d+/g, '').replace(/\?width=\d+/g, '');
    const finalSrc = normalizedSrc + (normalizedSrc.includes('?') ? '&width=900' : '?width=900');
    hoverImg.src = finalSrc;
    hoverImg.removeAttribute('srcset');
    hoverImg.style.display = '';
  } else {
    hoverImg.style.display = 'none';
  }
};

    let restoreImageTimer = null;

    const setCardImage = (src) => {
      if (!image || !src) return;
      const normalizedSrc = src.replace(/&width=\d+/g, '').replace(/\?width=\d+/g, '');
      const finalSrc = normalizedSrc + (normalizedSrc.includes('?') ? '&width=900' : '?width=900');

      if ((image.getAttribute('src') || '') === finalSrc) return;

      image.classList.add('is-swapping');
      window.clearTimeout(restoreImageTimer);
      window.setTimeout(() => {
        image.src = finalSrc;
        image.removeAttribute('srcset');
      }, 70);
      restoreImageTimer = window.setTimeout(() => {
        image.classList.remove('is-swapping');
      }, 220);
    };

const pickImageFromState = (variant) => {
  if (colorIndex !== null) {
    const selectedColor = optionState[colorIndex];
    if (selectedColor && colorImageMap[selectedColor]) return colorImageMap[selectedColor];
  }

  if (variant && variant.featured_image && variant.featured_image.src) {
    return variant.featured_image.src;
  }

  if (
    variant &&
    variant.featured_media &&
    variant.featured_media.preview_image &&
    variant.featured_media.preview_image.src
  ) {
    return variant.featured_media.preview_image.src;
  }

  if (defaultVariant && defaultVariant.featured_image && defaultVariant.featured_image.src) {
    return defaultVariant.featured_image.src;
  }

  return null;
};

if (defaultVariant) {
  optionState[0] = defaultVariant.option1 || optionState[0];
  optionState[1] = defaultVariant.option2 || optionState[1];
  optionState[2] = defaultVariant.option3 || optionState[2];

  if (hiddenVariantInput) hiddenVariantInput.value = defaultVariant.id;

  if (priceNode && typeof defaultVariant.price === 'number') {
    priceNode.textContent = money(defaultVariant.price);
  }

  const defaultImage = pickImageFromState(defaultVariant);
  if (defaultImage) setCardImage(defaultImage);

  setHoverImage(defaultVariant.hover_image || '');
}



    const syncFromState = () => {
  const variant = resolveVariant(optionState, variants);
  const nextImage = pickImageFromState(variant);
  if (nextImage) setCardImage(nextImage);

  setHoverImage(variant && variant.hover_image ? variant.hover_image : '');

      if (variant) {
        if (hiddenVariantInput) hiddenVariantInput.value = variant.id;
        if (priceNode && typeof variant.price === 'number') {
          priceNode.textContent = money(variant.price);
        }
        if (addButton) {
          const needsSize = addButton.hasAttribute('data-requires-size');
          const selectedSize = sizeIndex !== null ? optionState[sizeIndex] : true;
          addButton.disabled = !variant.available || (needsSize && !selectedSize);
          addButton.textContent = !variant.available ? 'Sold Out' : ((needsSize && !selectedSize) ? 'Select Size' : 'ADD');
        }
      } else if (addButton) {
        const needsSize = addButton.hasAttribute('data-requires-size');
        const selectedSize = sizeIndex !== null ? optionState[sizeIndex] : true;
        addButton.disabled = true;
        addButton.textContent = needsSize && !selectedSize ? 'Select Size' : 'Unavailable';
      }
    };

    const previewColorImage = (value) => {
      if (value && colorImageMap[value]) setCardImage(colorImageMap[value]);
    };

    const restoreCommittedImage = () => {
   const variant = resolveVariant(optionState, variants);
const nextImage = pickImageFromState(variant);
if (nextImage) setCardImage(nextImage);
setHoverImage(variant && variant.hover_image ? variant.hover_image : '');
    };

    card.querySelectorAll('[data-card-option]').forEach((button) => {
      const optionIndex = Number(button.getAttribute('data-option-index'));
      const value = button.getAttribute('data-option-value');

      if (colorIndex !== null && optionIndex === colorIndex) {
        button.addEventListener('mouseenter', () => previewColorImage(value));
        button.addEventListener('focus', () => previewColorImage(value));
        button.addEventListener('mouseleave', restoreCommittedImage);
        button.addEventListener('blur', restoreCommittedImage);
      }

     button.addEventListener('click', (event) => {
  event.preventDefault();
  event.stopPropagation();

  // 👇 THIS is where it goes
  optionState[optionIndex] = value;

  // 👇 ADD THIS RIGHT AFTER
  if (colorIndex !== null && optionIndex === colorIndex) {
    previewColorImage(value);
  }

  const wrap = button.parentElement;
  if (wrap) {
    wrap.querySelectorAll('[data-card-option]').forEach((item) => item.classList.remove('is-active'));
  }

  button.classList.add('is-active');

  syncFromState();
});
    });

    if (sizeIndex !== null && addButton) {
      optionState[sizeIndex] = null;
      addButton.disabled = true;
      addButton.textContent = 'Select Size';
    }

    syncFromState();

    if (addButton) {
      addButton.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantId = hiddenVariantInput ? hiddenVariantInput.value : '';
        if (!variantId || addButton.disabled) return;

        const original = addButton.textContent;
        addButton.disabled = true;
        addButton.textContent = 'Adding';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });

          if (!response.ok) throw new Error('Unable to add item');

          const cartOpen = document.querySelector('[data-cart-open]');
          if (cartOpen) {
            cartOpen.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          }

          addButton.textContent = 'Added';
          addButton.classList.add('is-added');
          setTimeout(() => {
            addButton.classList.remove('is-added');
            syncFromState();
          }, 850);
        } catch (e) {
          addButton.disabled = false;
          addButton.textContent = 'Error';
          setTimeout(() => {
            addButton.textContent = original;
            syncFromState();
          }, 900);
        }
      });
    }
  };

  document.querySelectorAll('[data-product-card]').forEach(setupCard);
})();




/* Collection left filter drawer */
(() => {
  const drawer = document.getElementById('CollectionFilterDrawer');
  if (!drawer) return;

  const openButtons = document.querySelectorAll('[data-filter-drawer-open]');
  const closeButtons = document.querySelectorAll('[data-filter-drawer-close]');

  const openDrawer = () => {
    document.body.classList.add('is-filter-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
  };

  const closeDrawer = () => {
    document.body.classList.remove('is-filter-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
  };

  openButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawer();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });
})();










document.addEventListener('click', (event) => {
  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');
  if (!minus && !plus) return;

  const wrap = event.target.closest('.pe-cart-line__qty');
  const input = wrap?.querySelector('input[type="number"]');
  if (!input) return;

  const current = parseInt(input.value || '0', 10);

  if (minus) input.value = Math.max(0, current - 1);
  if (plus) input.value = current + 1;
});






document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);

  if (params.get("openCart") === "1") {
    // Try common cart drawer triggers
    const cartButton =
      document.querySelector('[data-cart-open]') ||
      document.querySelector('[aria-label="Cart"]') ||
      document.querySelector('.cart-drawer-button');

    if (cartButton) {
      cartButton.click();
    }
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);

  // 🔍 OPEN SEARCH
  if (params.get("openSearch") === "1") {
    const searchButton = document.querySelector('[aria-label="Open search"]');

    if (searchButton) {
      searchButton.click();
    }
  }

  // 🛒 OPEN CART
  if (params.get("openCart") === "1") {
    const cartButton =
      document.querySelector('[data-cart-open]') ||
      document.querySelector('[aria-label="Cart"]') ||
      document.querySelector('.cart-drawer-button')||
          document.querySelector('[data-account-open]') ||
    document.querySelector('.header-icon--account');

    if (cartButton) {
      cartButton.click();
    }
  }
});
document.addEventListener('click', function (e) {
  const footerLogin = e.target.closest('.footer-login-trigger');
  const closeBtn = e.target.closest('[data-account-close]');

  // 👉 OPEN ACCOUNT
  if (footerLogin) {
    e.preventDefault();

    const accountButton =
      document.querySelector('[data-account-open]') ||
      document.querySelector('.header-icon--account');

    if (accountButton) {
      accountButton.click(); // ✅ same pattern as cart
    } else {
      window.location.href = '/?openAccount=1'; // fallback
    }
  }

  // 👉 CLOSE ACCOUNT
  if (closeBtn) {
    const drawer = document.querySelector('[data-account-drawer]');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('account-drawer-open');
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);

  if (params.get("openAccount") === "1") {
    const accountButton = document.querySelector('[data-account-open]');

    if (accountButton) {
      accountButton.click();
    }
  }
});





document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', () => {
    const answer = btn.nextElementSibling;
    answer.style.display = answer.style.display === 'block' ? 'none' : 'block';
  });
});


/* Carousel controls fix */



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('pe-carousel').forEach(function (carousel) {
    const trackWrap = carousel.querySelector('[data-track]');
    const prevBtn = carousel.querySelector('[data-prev]');
    const nextBtn = carousel.querySelector('[data-next]');

    if (!trackWrap || !prevBtn || !nextBtn) return;

    const getScrollAmount = function () {
      const firstCard = trackWrap.querySelector('.product-card, .promo-card');
      return firstCard ? firstCard.offsetWidth + 24 : trackWrap.clientWidth * 0.8;
    };

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      trackWrap.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      trackWrap.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });
  });
});
document.addEventListener('click', function(event) {
  const openBtn = event.target.closest('[data-account-open]');
  const closeBtn = event.target.closest('[data-account-close]');
  const drawer = document.querySelector('[data-account-drawer]');

  if (!drawer) return;

  if (openBtn) {
    event.preventDefault();

    // Optional: close mobile menu first
    const mobileDrawer = document.querySelector('[data-mobile-nav-drawer]');
    if (mobileDrawer) {
      mobileDrawer.classList.remove('is-open');
      document.body.classList.remove('mobile-nav-open');
    }

    drawer.classList.add('is-open');
    document.body.classList.add('account-drawer-open');
  }

  if (closeBtn) {
    event.preventDefault();
    drawer.classList.remove('is-open');
    document.body.classList.remove('account-drawer-open');
  }
});


document.addEventListener('DOMContentLoaded', function () {
  if (navigator.userAgent.includes("DuckDuckGo")) {
    console.log("DDG detected");

    document.querySelectorAll('.account-drawer__note--ddg').forEach(el => {
      el.style.display = 'block';
    });
  }
});